import React, { useMemo } from "react";
import img1 from "assets/images/users/1.jpg";
import { UncontrolledPopover, PopoverBody } from "reactstrap";
import { NotificationManager } from "react-notifications";
import { SelectionCell, SelectionHeader } from "components/react-table";
import { Link } from "react-router-dom";
import EditableCell from "./EditableCell";
import { GenericTable } from "./GenericTable";

const fixFloat = (num) => parseFloat(num.toFixed(2))

function isValidTime(date) {
    return (/^([0-1]?[0-9]|2[0-4]):([0-5][0-9])(:[0-5][0-9])?$/.test(date))
}

export const DailyTable = ({ t, fetch, UpdateTimeInOut, setSelectedRows, refetch, readOnly }) => {

    const updateValues = (column, obj, value) => {
        if (!isValidTime(value)) {
            NotificationManager.error(t('Value not valid'));
            return false
        }
        if (column === 'time_in') {
            UpdateTimeInOut([{ 'id': obj.id, 'time_in': value, 'time_out': obj.time_out, 'time_date': obj.time_date, 'employee': obj.employee_data.id }])
        } else {
            UpdateTimeInOut([{ 'id': obj.id, 'time_in': obj.time_in, 'time_out': value, 'time_date': obj.time_date, 'employee': obj.employee_data.id }])
        }

        return true
    }

    const columns = useMemo(
        () =>
            [
                {
                    id: "selection",
                    Cell: SelectionCell,
                    Header: SelectionHeader,
                    disableSortBy: true,
                },
                {
                    Header: t("Employee"),
                    accessor: "employee_data.full_name",
                    Cell: ({ value, row: { original } }) => (
                        <div className="text-left">
                            <img src={original.employee_data.employee_picture || img1} width="29" />
                            <Link to={`/payroll/employees/${original.employee_data.id}`}>
                                {value}
                            </Link>
                        </div>
                    ),

                },
                {
                    Header: t("Date"),
                    accessor: "time_date",
                },
                {
                    Header: t("Time In"),
                    accessor: "time_in",
                    disableSortBy: true,
                    Cell: readOnly ? ({ cell: { value } }) => {
                        return value ? value : "-"
                    }
                    : EditableCell,
                    style: { 'whiteSpace': 'unset' }
                },

                {
                    Header: t("Time out"),
                    accessor: "time_out",
                    disableSortBy: false,
                    Cell: readOnly ? ({ cell: { value } }) => {
                        return value ? value : "-"
                    }
                    : EditableCell,                
                },
                {
                    Header: t("Total Daily"),
                    accessor: "duration",
                    disableSortBy: true,
                },
                {
                    Header: t("Planned Daily"),
                    accessor: "fixed",
                    disableSortBy: true,
                },
                {
                    Header: t("Difference"),
                    accessor: "delay",
                    Cell: ({ cell: { value } }) => {
                        return (
                            <>
                                {fixFloat(value)} {t('h')}
                            </>
                        );
                    }
                },
                {
                    Header: t("Note"),
                    accessor: "note",
                    Cell: ({ cell: { value } }) => ( value ? <span>{t(value)}</span> : "")
                },
            ]
    );

    return (
        <GenericTable columns={columns} reload={false} fetch={fetch} setSelectedRows={setSelectedRows} refetch={refetch} CellChangeCallback={updateValues} key={'attendance'}/>
    );
};
